module.exports = __webpack_public_path__ + "img/full0-min.882aec9b.png";